import React, { useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Avatar, Typography, Button, Chip, Box } from "@material-ui/core";
import update_profile from "./update_profile";
import { useDispatch, useSelector } from "react-redux";
import { showModalPassword } from "redux/Action";
import { axios } from "./../../../../../../axios";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    minHeight: "fit-content",
  },
  avatar: {
    width: 70,
    height: 70,
  },
  smallAvatar: {
    width: 25,
    height: 25,
    position: "absolute",
    backgroundColor: "white",
    borderWidth: 0,
    top: 50,
    right: 115,
  },
  name: {
    marginTop: theme.spacing(3),
  },
  verifiedChip: {
    backgroundColor: theme.palette.success.main, // سبز
    color: theme.palette.success.contrastText,

    "& .MuiChip-label": {
      color: theme.palette.success.contrastText,
    },
  },
  unverified: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
}));

const Profile = (props) => {
  const { className, ...rest } = props;
  const current_role = useSelector((state) => state.role);

  const classes = useStyles();
  const dispatch = useDispatch();

  const token = useSelector((state) => state.token);
  const [data, setData] = React.useState([]);
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const GetData = async () => {
    try {
      const res = await axios.get(`auth/getCurrentUser`, {
        headers: headers,
      });
      // console.log(res.data,"ressss")
      setData(res.data);
    } catch (e) {
      console.log(e.response, "eeeeeeeee");
    }
  };

  useEffect(() => {
    GetData();
  }, []);

  const user = {
    name: "علی کارگر",
    avatar_men: "/images/avatars/boy.svg",
    avatar_women: "/images/avatars/person.svg",

    role: "باربری نمونه",
    jens: "مرد",
  };

  return (
    <div
      style={data.length != 0 ? { display: "flex" } : { display: "none" }}
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={user.avatar_men}
      />

      <Typography className={classes.name} variant="h4">
        {data?.full_name}
      </Typography>
      {/* <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      > */}
      <Typography variant="body2" style={{ margin: "4px 0px" }}>
        <small>
          {data.roles
            ? data.roles[0]?.name == "Staff"
              ? `(${data.staff?.company?.name} )`
              : data.roles[0]?.alias_title
            : ""}
        </small>
      </Typography>

      {current_role !== "Super-Admin" && (
        <Chip
          size="small"
          // color="primary"
          label={data.is_verified === 2 ? "احراز هویت شده" : "احراز هویت نشده"}
          className={
            data.is_verified === 2 ? classes.verifiedChip : classes.unverified
          }
        />
      )}
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string,
};

export default Profile;
